<template>
	<v-dialog v-model="Sip_investment_edit_form_dialog_status" persistent >
	    <v-card>
		    <v-card-title>
		      <span class="text-h5">Edit Form</span>
		    </v-card-title>
		    <v-card-text>
			    <v-container>
			      	<v-form ref="form" id="Sip_investment_edit_form_dialog" v-model="valid" lazy-validation @submit.prevent lazy-validation>
				        <v-row> 
					        <v-col cols="12" sm="1" md="4">
					            <label>Mutual Fund Company</label>
					            <v-select 
					              ref="mutual_fund_company"
					              name="mutual_fund_company"
					              v-model="selected_mutual_fund_company"
					              :items="mutual_fund_company_items"
					              item-value="name"
					              item-text="name"
					              placeholder=""
					              @change="removeError('mfc', $event)"
					            ></v-select>
								<p style="color: red !important">{{mutual_fund_company_warning_msg}}</p>
					        </v-col>
					        <v-col cols="12" sm="6" md="4">
					            <label>Scheme Type</label>
					            <v-select
					                ref="scheme_type"
					                name="scheme_type"
					                v-model="selected_scheme_type"
					                :items="scheme_type_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('scheme_type', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{scheme_type_warning_msg}}</p>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					            <label>Scheme Name</label>
					            <v-select
					                ref="scheme_name"
					                name="scheme_name"
					                v-model="selected_scheme_name"
					                :items="scheme_name_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('scheme_name', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{scheme_name_warning_msg}}</p>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					            <label>Account Owner</label>
					            <v-select
					                ref="account_owner_name"
					                name="account_owner_name"
					                v-model="selected_account_owner_name"
					                :items="account_owner_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('account_owner', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{account_owner_warning_msg}}</p>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					          	<label>SIP Start Date</label>
								<div  class="dob-box">
									<Datepicker
										name="sip_start_date" 
										ref="sip_start_date"
										v-model="sip_start_date"
										format="yyyy-MM-dd"
									></Datepicker>
								</div>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					          	<label>SIP End Date</label>
								<div  class="dob-box">
									<Datepicker
										name="sip_end_date" 
										ref="sip_end_date"
										v-model="sip_end_date"
										format="yyyy-MM-dd"
									></Datepicker>
								</div>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					          	<label>Monthly SIP Amount</label>
					            <v-text-field name="monthly_sip_amount" ref="monthly_sip_amount" v-model ="monthly_sip_amount"></v-text-field>
					        </v-col>
					        <v-col cols="12" sm="6" md="4">
					          	<label>Folio Number</label>
					            <v-text-field name="folio_number" ref="folio_number" v-model ="folio_number"></v-text-field>
					        </v-col>
							<v-col cols="12" sm="6" md="4">
					          	<label>Total Investment</label>
					            <v-text-field name="total_investment" ref="total_investment" v-model ="total_investment"></v-text-field>
					        </v-col>
							
							<v-col cols="12" sm="6" md="4">
					          	<label>Balance Unit</label>
					            <v-text-field name="balance_unit" ref="balance_unit" v-model ="balance_unit"></v-text-field>
					        </v-col>
					        <v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_1_select_box_status">Nominee 1 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_1')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 1 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_1')">remove dropdown</a></label>
					            <v-text-field name="nominee_1" ref="nominee_1" v-model="selected_nominee_1" v-if="!nominee_1_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_1"
					                name="nominee_1"
					                v-model="selected_nominee_1"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
							<v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_2_select_box_status">Nominee 2 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_2')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 1 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_2')">remove dropdown</a></label>
					            <v-text-field name="nominee_2" ref="nominee_2" v-model="selected_nominee_2" v-if="!nominee_2_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_2"
					                name="nominee_2"
					                v-model="selected_nominee_2"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
							<v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_3_select_box_status">Nominee 3 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_3')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 1 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_3')">remove dropdown</a></label>
					            <v-text-field name="nominee_3" ref="nominee_3" v-model="selected_nominee_3" v-if="!nominee_3_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_3"
					                name="nominee_3"
					                v-model="selected_nominee_3"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
				        </v-row>
				    </v-form>    
			    </v-container>
		    </v-card-text>
		    <v-card-actions>
		      <v-spacer></v-spacer>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="close"
		      >
		        Cancel
		      </v-btn>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="save"
		      >
		        Save
		      </v-btn>
		    </v-card-actions>
	    </v-card>
	</v-dialog>
</template>
<script>
    import axios from "axios";
    import { Auth } from "aws-amplify";
	import Datepicker from 'vuejs-datepicker';
    export default {
		components: {
		  Datepicker,
		},
	  	props: ['Sip_investment_edit_form_dialog_status', 'get_sip_investment_edit_form_data', 'get_member_list'],
	  	data: function () {
		    return { 
				mutual_fund_company_items:[],
				selected_mutual_fund_company:'',
				mutual_fund_company_warning_msg:'',
				mutual_fund_company_warning_status:false,
				account_owner_name:'',
                selected_account_owner_name:'',
				account_owner_items:[],
				account_owner_warning_msg:'',
				account_owner_warning_status:false,
				scheme_type:'',
                selected_scheme_type:'',
				scheme_type_items:[],
				scheme_type_warning_msg:'',
				scheme_type_warning_status:false,
				scheme_name:'',
                selected_scheme_name:'',
				scheme_name_items:[],
				scheme_name_warning_msg:'',
				scheme_name_warning_status:false,
				nominee_1:'',
				selected_nominee_1:'',
				nominee_2:'',
				selected_nominee_2:'',
				nominee_3:'',
				selected_nominee_3:'',
				nominee_items:[],
			    getFormData:'',
				folio_number:'',
				total_investment:'',
				balance_unit:'',
			    valid:null,
				Sip_investment_edit_form_dialog:this.Sip_investment_edit_form_dialog_status,
				nominee_1_select_box_status:false,
				nominee_2_select_box_status:false,
				nominee_3_select_box_status:false,
				sip_start_date:'',
				sip_end_date:'',
				monthly_sip_amount:'',
				bank_po_list:[],
				user_name:'',
				selected_mf_id:'',
				actual_mfc_list:[],
				actual_scheme_name_list:[],
				actual_mfc_list:[],
				actual_scheme_type_list:[],
				selected_scheme_type_id:''
		    }
		},

	    created (){
			this.$loading(true)
			setTimeout(()=>{
				this.setMasterData()
				Auth.currentAuthenticatedUser({
					bypassCache: false
				}).then(user => {	
					this.user_name = user.attributes["custom:name"];
					this.account_owner_items.push({'id':this.user_name, 'name':this.user_name});
				})
                
                let owner_error_cnt = 'yes';
				this.get_member_list.forEach(owner_detail => {
					if(owner_detail.id == 0  || owner_detail.name == null){
						this.account_owner_items.push({'id':this.user_name, 'name':this.user_name}); 
					}
					else{
						this.account_owner_items.push({'id':owner_detail.name, 'name':owner_detail.name});
					}
					if(this.get_sip_investment_edit_form_data.row_item_detail.owner !=null && this.get_sip_investment_edit_form_data.row_item_detail.owner == owner_detail.name){
						this.selected_account_owner_name = owner_detail.name
						owner_error_cnt = 'no';
					}
				})
				if(owner_error_cnt == 'yes'){
					this.account_owner_warning_msg  = 'Uploaded owner name ('+this.get_sip_investment_edit_form_data.row_item_detail.owner+') is not found in member list. Kindly choose from dropdown';
				}
				
				this.folio_number        = this.get_sip_investment_edit_form_data.row_item_detail.folio_number;
				this.balance_unit        = this.get_sip_investment_edit_form_data.row_item_detail.balance_units;
				this.total_investment    = this.get_sip_investment_edit_form_data.row_item_detail.total_investment;
				this.selected_nominee_1  = this.get_sip_investment_edit_form_data.row_item_detail.nominee_1;
				this.selected_nominee_2  = this.get_sip_investment_edit_form_data.row_item_detail.nominee_2;
				this.selected_nominee_3  = this.get_sip_investment_edit_form_data.row_item_detail.nominee_3;
				this.nominee_items       = this.account_owner_items;
				this.selected_mutual_fund_company = this.get_sip_investment_edit_form_data.row_item_detail.mutual_fund_company
				this.selected_scheme_type = this.get_sip_investment_edit_form_data.row_item_detail.selected_scheme_type
				this.selected_scheme_name = this.get_sip_investment_edit_form_data.row_item_detail.selected_scheme_name
				this.sip_start_date = this.get_sip_investment_edit_form_data.row_item_detail.sip_start_date
				this.sip_end_date = this.get_sip_investment_edit_form_data.row_item_detail.sip_end_date
				this.monthly_sip_amount = this.get_sip_investment_edit_form_data.row_item_detail.monthly_sip_amount
				this.balance_units = this.get_sip_investment_edit_form_data.row_item_detail.balance_units
                this.$loading(false)
			}, 2000);
	    },

	    methods: {
	    	chooseNominee(field_name){
	    		if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = true
	    		}
	    		else{

	    		}
	    	},

	    	typeNominee(field_name){
	    	    if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = false
	    		}
	    		else{

	    		}	
	    	},

	    	removeError(type, type_val){
		        if(type == 'mfc'){
					this.setMFMasterdata(type_val)	
		            this.mutual_fund_company_warning_msg = ''
		        }
		        else if(type == 'account_owner'){
		            this.account_owner_warning_msg = ''
				    this.nominee_items = [];
					this.joint_account_owner_items = [];
				    this.get_member_list.forEach(list=>{
						if(list.name !=type_val){
					    	this.nominee_items.push({'id':list.name, 'name':list.name});
							this.joint_account_owner_items.push({'id':list.name, 'name':list.name});
						}
				    })
		        }
				else if(type == 'scheme_type'){
                    this.scheme_type_warning_msg = ''
					this.setSchemeTypeId(type_val);
					
				}
				else if(type == 'scheme_name'){
                    this.scheme_name_warning_msg = ''
				}
		    },

			getBankPoData(type){
				this.bank_po_items = [];
				this.selected_account_type = type;
				if(type=='Bank'){
					this.bank_po_list = this.get_sip_investment_edit_form_data.bank_po_list['0'].bank_list;
				}
				else{
					this.bank_po_list = this.get_sip_investment_edit_form_data.bank_po_list['0'].post_office_list;
				}
				let bank_po_co_error_cnt = 'yes';
				this.bank_po_list.forEach(bank_po_detail => {
					this.bank_po_items.push({'id':bank_po_detail.name, 'name':bank_po_detail.name});
					if(this.get_sip_investment_edit_form_data.row_item_detail.bankpo_name == bank_po_detail.name){
						this.selected_bank_po_name = bank_po_detail.name;
						bank_po_co_error_cnt = 'no';
					}
				})
				if(bank_po_co_error_cnt == 'yes'){
					this.bank_po_warning_msg         = 'Uploaded Bank/PO not matched with list kindly select from dropdown'; 
					this.bank_po_warning_msg_status  = true;
				}
			},

		    close(){
                this.$emit('getSipInvestmentUpdatedFormData', false)
		    },

		    save(e){
				let is_form_valid  = true;
                this.getFormData = document.querySelector("#Sip_investment_edit_form_dialog");
				if(this.getFormData.mutual_fund_company.value ==''){
                   this.mutual_fund_company_warning_msg = "Choose Mutual Fund Company";
				   is_form_valid = false;
				}
				if(this.getFormData.scheme_type.value ==''){
                    this.account_owner_warning_msg = "Choose Valid Scheme Type";
					is_form_valid = false;
				}
				if(this.getFormData.scheme_name.value ==''){
                   this.joint_account_owner_warning_msg = "Choose valid scheme name";
				   is_form_valid  = false;
				}
				if(this.getFormData.account_owner_name.value ==''){
                   this.account_owner_name_warning_msg = "Choose Valid Account Owner Name";
				   is_form_valid  = false;
				}
				if(is_form_valid  == true){
					let form_array_object = {'folio_number' :this.getFormData.folio_number.value, 
											'mutual_fund_company':this.getFormData.mutual_fund_company.value, 
											'scheme_type':this.getFormData.scheme_type.value,
											'scheme_name':this.getFormData.scheme_name.value, 
											'is_account_owner_valid':true, 
											'is_mutual_fund_company_valid':true,
											'is_scheme_type_valid':true,
											'is_scheme_name_valid':true, 
											'total_investment':this.getFormData.total_investment.value, 
											'nominee_1':this.getFormData.nominee_1.value,
											'nominee_2':this.getFormData.nominee_2.value,
											'nominee_3':this.getFormData.nominee_3.value,
											'owner':this.getFormData.account_owner_name.value,
											'sip_start_date':this.getFormData.sip_start_date.value,
											'sip_end_date':this.getFormData.sip_end_date.value,
											'monthly_sip_amount':this.getFormData.monthly_sip_amount.value,
											'balance_units':this.getFormData.balance_unit.value
			                        	};	 			
                    this.$emit('getSipInvestmentUpdatedFormData', form_array_object);
				}
		    },


			setMasterData() {
				this.mf_master_data = []
				let formdata    = new FormData();
				formdata.append("aws_cognito_id", localStorage.getItem('cognito_idp'));
				axios.post( process.env.VUE_APP_ROOT_API+'get-mf-master-data-lists',
					formdata,{
						headers: {
						}
					}
				).then((response) => {
					let mfc_error_cnt = 'yes';
					let scheme_type_error_cnt = 'yes';
					let scheme_name_error_cnt = 'yes';
					this.mutual_fund_company_items=[];
					this.scheme_name_items =[];
					this.actual_mfc_list = response.data.data.list.mfc_list;
					this.actual_scheme_name_list= response.data.data.list.scheme_name_list;
					this.actual_scheme_type_list = response.data.data.list.scheme_types_list;
					response.data.data.list.mfc_list.forEach(mfc_detail => {
						this.mutual_fund_company_items.push({'id':mfc_detail.name, 'name':mfc_detail.name});
						if(mfc_detail['name']  == this.get_sip_investment_edit_form_data.row_item_detail.mutual_fund_company){
							mfc_error_cnt = 'no';
							this.selected_mf_id = mfc_detail.id
							this.selected_mutual_fund_company =  this.get_sip_investment_edit_form_data.row_item_detail.mutual_fund_company;
						}
					})
					response.data.data.list.scheme_types_list.forEach(scheme_type_detail => {
						this.scheme_type_items.push({'id':scheme_type_detail.name, 'name':scheme_type_detail.name});
						if(scheme_type_detail['name']  == this.get_sip_investment_edit_form_data.row_item_detail.scheme_type){
							scheme_type_error_cnt = 'no'; 
							this.selected_scheme_type =  scheme_type_detail['name'];
							this.selected_scheme_type_id = scheme_type_detail['id'];
						}
					})
					if(this.selected_mf_id !=''){
						response.data.data.list.scheme_name_list.forEach(scheme_name_detail => {
							if(this.selected_scheme_type_id !=''){
                                if(this.selected_mf_id == scheme_name_detail.mfc_id && this.selected_scheme_type_id == scheme_name_detail.scheme_type_id){
									this.scheme_name_items.push({'id':scheme_name_detail.name, 'name':scheme_name_detail.name});
									if(scheme_name_detail['name']  == this.get_lumpsum_investment_edit_form_data.row_item_detail.scheme_name){
										scheme_name_error_cnt = 'no'; 
										this.selected_scheme_name =  scheme_name_detail['name'];
									}
							    }
							}
							else{
								if(this.selected_mf_id == scheme_name_detail.mfc_id){
									this.scheme_name_items.push({'id':scheme_name_detail.name, 'name':scheme_name_detail.name});
									if(scheme_name_detail['name']  == this.get_lumpsum_investment_edit_form_data.row_item_detail.scheme_name){
										scheme_name_error_cnt = 'no'; 
										this.selected_scheme_name =  scheme_name_detail['name'];
									}
							    }
							}
						})
					}
					else{
						response.data.data.list.scheme_name_list.forEach(scheme_name_detail => {
							this.scheme_name_items.push({'id':scheme_name_detail.name, 'name':scheme_name_detail.name});
							if(scheme_name_detail['name']  == this.get_lumpsum_investment_edit_form_data.row_item_detail.scheme_name){
								scheme_name_error_cnt = 'no'; 
								this.selected_scheme_name =  scheme_name_detail['name'];
							}
						})
					}
					if(mfc_error_cnt == 'yes'){
						this.mutual_fund_company_warning_msg  = 'Uploaded MFC ('+this.get_sip_investment_edit_form_data.row_item_detail.mutual_fund_company+') is not found in member list. Kindly choose from dropdown';
					}

					if(scheme_type_error_cnt == 'yes'){
						this.scheme_type_warning_msg  = 'Uploaded Scheme Type ('+this.get_sip_investment_edit_form_data.row_item_detail.scheme_type+') is not found in member list. Kindly choose from dropdown';
					}

					if(scheme_name_error_cnt == 'yes'){
						this.scheme_name_warning_msg  = 'Uploaded Scheme Name ('+this.get_sip_investment_edit_form_data.row_item_detail.scheme_name+') is not found in member list. Kindly choose from dropdown';
					}
					this.$loading(false)
					}).catch(() => {});  
			},

			setMFMasterdata(val){
				this.scheme_name_items =[];
				this.actual_mfc_list.forEach(mfc_detail => {
					if(this.selected_mutual_fund_company == mfc_detail.name){
						this.actual_scheme_name_list.forEach(scheme_name_detail => {
							if(mfc_detail['id']  == scheme_name_detail['mfc_id'] && this.selected_scheme_type_id == scheme_name_detail.scheme_type_id){
								this.scheme_name_items.push({'id':scheme_name_detail.name, 'name':scheme_name_detail.name}); 	
							}
						})
					}			
				})
			},

			setSchemeTypeId(val){
				console.log(val)
				this.actual_scheme_type_list.forEach(act_scheme_type_detail => {
					if(val == act_scheme_type_detail.name){
						this.selected_scheme_type_id = act_scheme_type_detail.id;
					}			
				})
				this.setMFMasterdata('')
			}

	    }

		
		
    }
</script>